/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { StorageModule } from "@vlinder-web/storage-module-react";
import { VANTR_ILLUSTRATION_IMAGE, BANNER_IMAGE, PLT_LOGO, PLT_LOGO_WHITE} from "../assets";
const storageService = StorageModule.getInstance();
const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");
const ODD_COLOR ="#f0f0f0"

//Branding Details

export {
    PLT_LOGO,
    PLT_LOGO_WHITE,
    VANTR_ILLUSTRATION_IMAGE
};

export const PRIMARY_COLOR = "#FF336F";
export const SECONDARY_COLOR= "";
export const DARK_THEME = false;
export const DARK_THEME_TEXT_COLOR = "#9f9f9f";

/* My Product Detail, Product Detail and MyWallet */

export const LOADING_ASSET_IMAGE = 'https://i.ibb.co/VNb2h39/shreedigital-asset-loading-750-700.png';
export const LOGIN_BG_IMAGE = 'https://i.ibb.co/R4V97JT/login-bg.png';
export const PROVE_YOUR_WALLET_ADDRESS ="https://i.ibb.co/dfrzBY4/shreedigital-prove-wallet-address-750-700.png";
export const PROFILE_NOT_FOUND = "https://i.ibb.co/k1JQ0k1/shreedigital-profile-not-found-750-700.png";
export const DIGITAL_SIGN = "https://i.ibb.co/V99hGkJ/shreedigital-digital-signature-750-700.png";
export const NO_ASSET = require('../assets/res/images/no-asset.webp');

export const LINKEDIN_ICON = require("../assets/res/images/linkedin.svg");
export const INSTAGRAM_ICON = require("../assets/res/images/instagram.svg");
export const FACEBOOK_ICON = require("../assets/res/images/facebook.webp");
export const EMAIL_ICON = require("../assets/res/images/mail.webp");
export const TWITTER_ICON = require("../assets/res/images/twitter.svg");
export const WHATSAPP_ICON = require("../assets/res/images/whatsapp.svg");
export const COPY_ICON = require("../assets/res/images/copy.png");

export const LINKEDIN_WHITE_ICON = require("../assets/res/images/linkedin-white.svg");
export const INSTAGRAM_WHITE_ICON = require("../assets/res/images/instagram-white.svg");
export const FACEBOOK_WHITE_ICON = require("../assets/res/images/facebook-white.webp");
export const EMAIL_WHITE_ICON = require("../assets/res/images/mail-white.webp");
export const TWITTER_WHITE_ICON = require("../assets/res/images/twitter-white.svg");
export const WHATSAPP_WHITE_ICON = require("../assets/res/images/whatsapp-white.svg");
export const COPY_WHITE_ICON = require("../assets/res/images/copy-white.png");

/* My Profile screen */
export const PROFILE_LOADING = 'https://i.ibb.co/qYbF7t5/shreedigital-profile-loading-750-700.png';

/* My Wallet and My Transactions screen */
export const EMPTY_IMAGE = require('../assets/res/images/empty.webp');
export const WALLET_LOADING = 'https://i.ibb.co/tLwX1Qr/shreedigital-wallet-loading-750-700.png';

/*Sign up screen */

export const CONTACT_SIGNUP_BG="https://i.ibb.co/MV0RhHx/signup-bg.png";

/* landing page contents */

export const CONTENTS = [
    {
        type: "intro-left",
        title: "ShreeDigital",
        text: [
            "Creating Legacy of Indian Liberal Arts - through NFTs",
        ],
        // icon:  VANTR_ILLUSTRATION_IMAGE,
        slider: false,
        sideLength: { xs: 64, sm: 64, md: 100, lg: 100, xl: 120 },
        columns: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 },
        // button: [
        //      {
        //         title: "More Details",
        //         link: "#about",
        //     },
        // ],
        id: "nft",
        imageBg: BANNER_IMAGE,
        titleStyle: { color: '#fff' },
        contentStyle: {color: '#fff'},
        wave: true,
    },
    {
        id: "about",
        type: "middle",
        title: "Welcome to ShreeDigital",
        text: ["Creating Legacy of Indian Liberal Arts - through NFTs"],
        // button: "Get Started",
        // link: "#contact",
    },
    {
        type: "right",
        title: "Books",
         bgColor: ODD_COLOR,
        text:  [
            "If you are an author, or you own the publishing rights of any work, or you are a journalist, you can now sell and earn with your work by directly selling them to the readers",
            "Enable Authors and journalists to engage and up-sell services to NFT owners.",
        ],
        icon: [
            `https://i.ibb.co/82ZqSvL/b1.jpg`,
            `https://i.ibb.co/zhTSY2p/pexels-pixabay-433333.jpg`,
            `https://i.ibb.co/Lnc8F3S/pexels-ricardo-esquivel-1907785.jpg`,
            `https://i.ibb.co/wgvG4cq/pexels-pixabay-159872.jpg`,
            `https://i.ibb.co/QYN2QPr/vv21.jpg`,
            `https://i.ibb.co/MNXVDQ5/pexels-oziel-g-mez-2846814.jpg`
        ],
        sideLength: { xs: 64, sm: 64, md: 80, lg: 80, xl: 100 },
        columns: { xs: 2, sm: 2, md: 3, lg: 3, xl: 3 },
        // button: [
        //     {
        //         title: "EXPLORE",
        //         link: "/collection/books",
        //     },
        // ],
        id: "books",
    },
    {
        type: "left",
        first: "true",
        icon: [
            `https://i.ibb.co/ggSMB9w/img-1.webp`,
            `https://i.ibb.co/vhTbmps/img-2.webp`,
            `https://i.ibb.co/Dk7NxvB/img-3.webp`,
            `https://i.ibb.co/W07XC8r/img-4.webp`,
            `https://i.ibb.co/VxM5x61/img-5.webp`,
            `https://i.ibb.co/8cVtWfk/img-6.webp`,
        ],
        sideLength: { xs: 64, sm: 64, md: 80, lg: 80, xl: 100 },
        columns: { xs: 2, sm: 2, md: 3, lg: 3, xl: 3 },
        title: "Music",
        text: ["Create, Buy, Sell and Earn with your music NFTs such as Album Releases, Beat Selling, etc.",
            "Enable Music producers and artists to engage and up-sell services to NFT owners."],
        // button: [
        //     {
        //         title: "EXPLORE",
        //         link: "/collection/music"
        //     },
        // ],
        id: "music",
    },
    {
        type: "right",
        title: "Art",
         bgColor: ODD_COLOR,
        text: [
            "Collecting art has generally been an honor of the chosen handful",
            "Enable Artists and Organisations to engage and up-sell services to NFT owners."
        ],
        icon: [
            `https://i.ibb.co/N66N0vx/pexels-steve-johnson-1572386.jpg`,
            `https://i.ibb.co/Z692NTK/pexels-steve-johnson-1690351-1.jpg`,
            `https://i.ibb.co/NSDHL29/pexels-steve-johnson-1585325.webp`,
            `https://i.ibb.co/59HmZMG/pexels-pixabay-161154.jpg`,
            `https://i.ibb.co/3mH8GfR/pexels-ann-h-1762851.webp`,
            `https://i.ibb.co/z66ztdC/pexels-alexander-grey-1149019.jpg`,
        ],
        sideLength: { xs: 64, sm: 64, md: 80, lg: 80, xl: 100 },
        columns: { xs: 2, sm: 2, md: 3, lg: 3, xl: 3 },
        // button: [
        //     {
        //         title: "EXPLORE",
        //         link: "/collection/art"
        //     },
        // ],
        id: "art",
    },
    {
        type: 'benefits',
        title: 'Features',
        id: 'features',
        content: [
            {
                url: `https://i.ibb.co/YhMR4Fg/shreedigital-phygital-200-200.webp`,
                title: "Phygital",
                description: "Tying digital asset to physical asset"
            },
            {
                url: `https://i.ibb.co/gr93xWL/shreedigital-api-200-200.webp`,
                title: "API",
                description: "Integration to mint via api's"
            },
            {
                url: `https://i.ibb.co/hZ80Jkv/shreedigital-user-engagement-200-200.webp`,
                title: "Collector/Fan Engagement",
                description: "From Seller to Purchaser"
            },
            {
                url: `https://i.ibb.co/744HcPv/shreedigital-wallet-200-200.webp`,
                title: "Wallet",
                description: "For Collector"
            },
            {
                url: `https://i.ibb.co/HgzgZn8/shreedigital-customized-storefront-200-200.webp`,
                title: "Customized Storefront",
                description: "For Seller"
            },
            {
                url: `https://i.ibb.co/nbXK4cL/shreedigital-mintpad-200-200.webp`,
                title: "Mintpad",
                description: "For Minters"
            },
        ]
    }
];

export const FOOTER = [
    {
        title: "Company",
        type: "large",
        section: [
            {
                link: "#",
                text: "About Us",
                target: '_blank'
            },
            {
                link: "/collection/books",
                text: "Books",
                target: '_self'
            },
            {
                link: "/collection/music",
                text: "Music",
                target: '_self'
            },
            {
                link: "/collection/art",
                text: "Art",
                target: '_self'
            },
            {
                link: DEFAULT_APP_CONFIG?.organization?.faqURL,
                text: "FAQ",
                target: '_blank'
            },
        ],
    },
    {
        title: "Policy",
        type: "large",
        section: [
            {
                link: "/privacy",
                text: "Privacy Policy",
                target: '_blank'
            },
            {
                link: "/terms",
                text: "Terms and Condition",
                target: '_blank'
            },
        ],
    },
    {
        title: "Address",
        type: "para",
        section: [
            {
                text: "Chennai, India",
            },
        ],
    },
];

export const LOGO = {
    img: PLT_LOGO,
    width: 225,
    height: 55,
};

export const SOCIAL = [
    {
        type: "linkedin",
        link: "#",
    },
    {
        type: "twitter",
        link: "#",
    },
    {
        type: "instagram",
        link: "#",
    },
    {
        type: "facebook",
        link: "#",
    },
    {
        type: "email",
        link: "mailto:gljshreedigital@gmail.com",
    },
    // {
    //     type: "phone",
    //     link: "tel:919844981710",
    // },
];

export const CONTACT = {
    title: "How can we help ?",
    subject: "NFT Enquiry",
    text: "For all queries, Please email us using this form",
    url: DEFAULT_APP_CONFIG?.organization?.contactUs,
    appId:DEFAULT_APP_CONFIG?.organization?.appId,
    action: "query_request",
    id: "contact",
};

export const STORE = {
    comingSoon: true,
    title: "Are you ready to own your NFT's?",
    content: "Download Shree Digital Wallet and experience yourselves",
    iosStoreUrl:
        "https://www.apple.com/app-store/",
    androidStoreUrl:
        "https://play.google.com/store/",
    id: "store",
};

export const CUSTOMER = {
    title: 'Our customers and partners',
    bgColor: ODD_COLOR,
    id: 'customer',
    content: [
        require("../assets/res/images/cust/diacc.webp"),
        require("../assets/res/images/cust/diagon.webp"),
        require("../assets/res/images/cust/ins.webp"),
        require("../assets/res/images/cust/amrut.webp"),
        require("../assets/res/images/cust/rcee.webp"),
        require("../assets/res/images/cust/skm.webp"),
        require("../assets/res/images/cust/tribe.webp"),
        require("../assets/res/images/cust/wdv.webp"),
        require("../assets/res/images/cust/wl.webp"),
        require("../assets/res/images/cust/sap.webp"),
    ]
};

export const CONTACT_SIGNUP = {
    title: "Mint your NFTs with ShreeDigital",
    subject: "ShreeDigital Signup",
    title1:"ShreeDigital Signup",
    title2: "Collector community?",
    content: `<p style={line-height:0.8rem}>Create Digital Twin of your unique asset, List & Sell as NFT.</p> <p style={line-height:0.8rem}>Create Custom Branded NFT storefront.  Go to market in weeks!</p>`,
    content2: `<p style={line-height:0.8}rem>Collectors: Create Digital Twin as NFTs & display collection </p> <p style={line-height:0.8rem}>Dealers: Create Digital Twin, List & Sell</p> <p style={line-height:0.8rem}>Auction Houses: Create Digital Twin, List & Sell in your custom storefront.</p><p>Understand steps for asset creation: <a href=${DEFAULT_APP_CONFIG?.organization?.faqOrgURL} target="_blank">Organization user</a>, <a href=${DEFAULT_APP_CONFIG?.organization?.faqIndURL} target="_blank">Individual User</a></p>`,
    url: DEFAULT_APP_CONFIG?.organization?.contactUs,
    appId:DEFAULT_APP_CONFIG?.organization?.appId,
    action: "onboard_request",
    id: "contact",
};